import React, { memo } from 'react';

import Button from '@skippay/core/components/Button';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import useAuthLinksByCountry from 'hooks/useAuthLinksByCountry';
import commonLabels from 'i18n/labels';

const AuthLoginRedirectButton = memo(function AuthLoginRedirectButton(props) {
	const { loginLink } = useAuthLinksByCountry();
	return (
		<Button
			to={loginLink}
			variant="secondary"
			testId="goToLogin"
			analyticsId="goToLogin"
			width="full"
		>
			{props.children || <FormattedMessage {...commonLabels['labels.toSignInScreen']} />}
		</Button>
	);
});

export default AuthLoginRedirectButton;
